import React, {useCallback, useEffect, useMemo, useState} from 'react';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import MenuItem from "@mui/material/MenuItem";
import UtilityService from "../../../../../API/common/UtilityService";
import NameModal from "../../../modal/NameModal";
import UtilityCustomerService from "../../../../../API/customer/UtilityCustomerService";
import {useLocation} from "react-router-dom";

const FilesTable = ({
                        nameOrder,
                        year,
                        orderId,
                        change,
                        setChange,
                        handleModalAlert,
                        customer,
                        orderCustomerInOrganization,
                        service
                    }) => {
    const pathname = useLocation().pathname

    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);

    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    useEffect(() => {
        getStartPageSize()
        const api = orderCustomerInOrganization ? UtilityService.getOrderCustomerInOrganization : service.getAllProjectFileNames
        api(orderId).then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [change]);

    const handleDeleteRow = useCallback(
        (row) => {
            service.delete(row.id)
                .then(function () {
                    setData(prev => prev.filter(el => el.id !== row.id))
                    setTableOptions((prev) => ({...prev, totalElements: data.length - 1}))
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [data],
    );
    const handleEdtRow = (row) => {
        setCurrentEditRowData(row)
        setModal(true)
    }

    const handleUpdate = (value) => {
        setLoading(true)
        service.editFile(currentEditRowData.id, {
            "description": value.name,
        })
            .then(function (response) {
                setData(prev => prev.map(el => el.id === currentEditRowData.id ? response.data : el))
                setModal(false)
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }

    const menuItem = [
        {type: "edit", text: "Изменить", handler: handleEdtRow},
        {type: "delete", text: "Удалить  файл", handler: handleDeleteRow}]

    const columns = useMemo(
        () => [
            {
                id: 'nameFile',
                header: 'Наименование файла',
                accessorKey: 'nameFile',
                minSize: 650,
                Cell:
                    ({cell, row}) => <a
                        onClick={() => {
                            const link = document.createElement('a');
                            link.href = row.original.path;
                            link.setAttribute('download', row.original.nameFile);
                            document.body.appendChild(link);
                            link.click();
                            console.log(link)
                        }}>{row.original.nameFile}</a>
            },
            {
                id: 'description',
                header: 'Описание',
                accessorKey: 'description',
                minSize: 650,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
        ],
        [data, setData],
    );

    return (
        <Box sx={{maxWidth: "1500px"}}>
            <Box sx={{overflow: 'auto'}}>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTopToolbarProps={{
                        sx: {
                            "& .MuiBox-root": {
                                padding: 0
                            }
                        }
                    }}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "&:first-of-type": !orderCustomerInOrganization && {
                                padding: 0,
                                width: "50px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (theme) => theme.palette.text.light,
                                "& .MuiButtonBase-root": {
                                    borderRadius: "4px",
                                    width: "24px",
                                    height: "24px",
                                    opacity: 1,
                                    margin: 0,
                                    padding: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    }
                                }
                            },
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                cursor: "pointer",
                                "&:hover": {
                                    textDecoration: "underline"
                                }

                            }
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem",
                            "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                "minWidth": "100%"
                            }
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}

                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                    }}
                    getRowId={(originalRow) => originalRow.id}
                    columns={columns}
                    data={data}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    state={{showGlobalFilter: true, pagination: tableOptions,}}
                    rowCount={tableOptions.totalElements}
                    enableRowSelection={false}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                    }}
                    localization={MRT_Localization_RU}
                    muiTableContainerProps={{
                        sx: {
                            maxHeight: `calc(100vh - 600px)`,
                            width: "1500px"
                        }
                    }}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        return <MenuItem
                            key={el.type}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                    enableRowActions={!orderCustomerInOrganization}
                    enableToolbarInternalActions={false}
                />
            </Box>
            <NameModal
                title={"Изменить"}
                open={modal} onClose={() => setModal(false)}
                handleSubmit={handleUpdate}
                initValue={{name: currentEditRowData?.description}}
                label={"Описание"}
                loading={loading}
            />
        </Box>
    );
};


export default FilesTable;